import { MultiSelectOption } from './MultiSelectList';

export type GroupOptionSource = {
    id: string;
    name?: string;
    parentId?: string;
};

type GroupOptionTreeOptions = {
    getLabel?: (group: GroupOptionSource, isLeaf: boolean) => string;
};

export const buildGroupOptionTree = (
    groups: GroupOptionSource[],
    options?: GroupOptionTreeOptions,
): MultiSelectOption[] => {
    if (!groups.length) {
        return [];
    }

    const nodeMap = new Map<
        string,
        MultiSelectOption & { suboptions: MultiSelectOption[] }
    >();
    const parentsWithChildren = new Set<string>();

    for (const group of groups) {
        if (group.parentId) {
            parentsWithChildren.add(group.parentId);
        }
    }

    for (const group of groups) {
        const isLeaf = !parentsWithChildren.has(group.id);
        const trimmedName = group.name?.trim();
        const baseLabel = trimmedName?.length ? trimmedName : group.id;
        const label = options?.getLabel?.(group, isLeaf) ?? baseLabel;

        nodeMap.set(group.id, {
            label,
            value: group.id,
            suboptions: [],
        });
    }

    const roots: MultiSelectOption[] = [];

    for (const group of groups) {
        const node = nodeMap.get(group.id);
        if (!node) {
            continue;
        }

        if (group.parentId && nodeMap.has(group.parentId)) {
            const parentNode = nodeMap.get(group.parentId);
            parentNode?.suboptions?.push(node);
        } else {
            roots.push(node);
        }
    }

    const sortNodes = (nodes: MultiSelectOption[]) => {
        nodes.sort((a, b) => a.label.localeCompare(b.label));
        for (const child of nodes) {
            if (child.suboptions?.length) {
                sortNodes(child.suboptions);
            }
        }
    };

    sortNodes(roots);

    return roots;
};
